import { Route, Switch } from 'wouter-preact'

import { DashboardDAppTemplate, DashboardTemplate } from 'components'
import { DAppWorkspaceTab, NotFoundPage, SettingsPage } from 'components/pages'
import { config } from 'config'

import {
	DAppDashboard,
	DAppsPage,
	HomePage,
	Layout,
	TeamsRoutes,
	ProfilePage
} from '../pages'

const AuthenticatedRoutes = () => (
	<Switch>
		<Route path='/dapp/:projectId' nest>
			<DashboardTemplate>
				<Route component={DAppDashboard} path='/' />
				<Route component={SettingsPage} path='/settings' />

				<Route path='/smart-contract/:dAppName' nest>
					<DashboardDAppTemplate>
						<Route component={DAppWorkspaceTab} path='/workspace' />
					</DashboardDAppTemplate>
				</Route>
			</DashboardTemplate>
		</Route>

		<Route path='/' nest>
			<Layout>
				<Route component={HomePage} path='/' />
				<Route component={DAppsPage} path='/dapps' />
				<Route component={ProfilePage} path='/profile' />

				{config.ENABLE_PAYMENTS && (
					<Route component={TeamsRoutes} path='/teams' nest />
				)}
			</Layout>
		</Route>

		<Route component={NotFoundPage} />
	</Switch>
)

export { AuthenticatedRoutes }
